import {Injectable, OnDestroy} from '@angular/core';
import {MedicalRecordProblemModel} from '../../api/model/medicalRecordProblem.model';
import {MedicalProblemRepository} from './ngrx/medicalProblem.repository';
import {MedicalProblemDataServiceAdapter} from './ngrx/medicalProblemDataService.adapter';
import {AbstractFindAllService} from '../../../../../core/service/v2/service/findAll/abstractFindAll.service';

@Injectable()
export class MedicalProblemFindAllService extends AbstractFindAllService<MedicalRecordProblemModel, MedicalRecordProblemModel>
    implements OnDestroy{

    public constructor(service: MedicalProblemRepository,
                       dataService: MedicalProblemDataServiceAdapter) {
        super(service, dataService);
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
